import { Component } from '@angular/core';
import { BeesFooterComponent } from '../bees-footer/bees-footer.component';
import { BeesHeaderComponent } from '../bees-header/bees-header.component';

@Component({
  selector: 'app-hydrographic-survey',
  standalone: true,
  imports: [BeesFooterComponent, BeesHeaderComponent],
  templateUrl: './hydrographic-survey.component.html',
  styleUrl: './hydrographic-survey.component.scss'
})
export class HydrographicSurveyComponent {

}
